import { IAppState } from '../../redux';

export const getProblemReasons = (state: IAppState) => {
  return state.billingStatus && state.billingStatus.problemReasons || {};
};
